/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The DigitalCertificateRequest model module.
 * @module model/DigitalCertificateRequest
 * @version 1.0.0
 */
class DigitalCertificateRequest {
    /**
     * Constructs a new <code>DigitalCertificateRequest</code>.
     * @alias module:model/DigitalCertificateRequest
     * @param idProductAttribute {Number} 
     */
    constructor(idProductAttribute) { 
        
        DigitalCertificateRequest.initialize(this, idProductAttribute);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, idProductAttribute) { 
        obj['id_product_attribute'] = idProductAttribute;
    }

    /**
     * Constructs a <code>DigitalCertificateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/DigitalCertificateRequest} obj Optional instance to populate.
     * @return {module:model/DigitalCertificateRequest} The populated <code>DigitalCertificateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new DigitalCertificateRequest();

            if (data.hasOwnProperty('id_product_attribute')) {
                obj['id_product_attribute'] = ApiClient.convertToType(data['id_product_attribute'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id_product_attribute
 */
DigitalCertificateRequest.prototype['id_product_attribute'] = undefined;






export default DigitalCertificateRequest;

